import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';

export const ReoRecord = z.object({
  processedDate: zodDateOrString,
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type ReoRecord = z.infer<typeof ReoRecord>;

export const ReoRecordInput = ReoRecord.pick({
  processedDate: true,
});
export type ReoRecordInput = z.infer<typeof ReoRecordInput>;
